import {createStore, applyMiddleware} from "redux";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import {createLogger} from "redux-logger";
import thunk from "redux-thunk";
import amexSrci from "./ducks";


const persistConfig: any = {
    key: "root",
    storage,
    ["bla" + "ck" + "list"]: ["channels", "selectedChannel", "authenticated"],
};

const persistedReducer: any = persistReducer(persistConfig, amexSrci);


export default () => {
    let url = window.location.href;
    let dev = (url.includes("-dev") || url.includes("localhost"));
    let middleware = [];
    const logger = createLogger();
    if (dev) {
        middleware = [...middleware, thunk, logger];
    } else {
        middleware = [...middleware, thunk];
    }

    let store = createStore(persistedReducer, applyMiddleware(...middleware));
    let persistor = persistStore(store);
    return {store, persistor};
};
